import { TableCell, styled } from "@mui/material";

const SizedTableCell = styled(TableCell)`
  width: ${({ width }) => width ?? "auto"};
  border-right: ${({ theme, rowSpan }) => rowSpan > 1 ? `1px dashed ${theme.colors.grey._100}` : `none`};
`;

export default SizedTableCell;
